<div class="sgt-campanha-cupons-form">
    <div class="card">
        <div class="card-header">
            <h6 class="card-title">
                <i class="fas fa-tags"></i> Cupons
            </h6>
            <small class="card-subtitle">
                Cupons que podem ser utilizados nesta campanha, por exemplo: cupons de desconto, cupons de frete grátis, cashback, etc.
            </small>
        </div>
        <div class="card-body">
            <form #form novalidade>
                <div class="row">
                    <div class="form-group col-12 mb-0">
                        <!-- <label for="cupons" class="col-form-label">Cupons</label> -->
                        <sgt-tokenfield
                            [(ngModel)]="cupons"
                            (ngModelChange)="cuponsChange.emit($event)"
                            name="cupons"
                            id="cupons"
                            [createTokensOnBlur]="true"
                            inputType="text"
                            tokenDuplicateMessage='Cupom já adicionado'
                            #cuponsField="ngModel"
                            #cuponsTokenfield
                            [ngControl]="cuponsField"
                            [disabled]="!canEdit"
                            [readonly]="!canEdit"
                            [uppercase]="true">
                        </sgt-tokenfield>
                        <p class="form-text text-muted" *ngIf="canEdit">
                            Exemplos: CUPOM10, FRETEGRATIS, CASHBACK20
                        </p>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>